<template>
  <svg
    class="ico"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="stroke"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path v-for="(d, i) in paths" :key="i" :d="d"/>
  </svg>
</template>

<script>
/**
 * 内联 SVG 图标集（24x24 线性图标，颜色继承 currentColor）
 */
const ICONS = {
  thermometer: ['M14 14.76V5a2 2 0 0 0-4 0v9.76a4 4 0 1 0 4 0z'],
  drop: ['M12 3.2s6 6.3 6 10.3a6 6 0 1 1-12 0c0-4 6-10.3 6-10.3z'],
  sun: [
    'M12 8.2a3.8 3.8 0 1 0 0 7.6 3.8 3.8 0 0 0 0-7.6z',
    'M12 2.6v2.2M12 19.2v2.2M4.3 4.3l1.6 1.6M18.1 18.1l1.6 1.6M2.6 12h2.2M19.2 12h2.2M4.3 19.7l1.6-1.6M18.1 5.9l1.6-1.6'
  ],
  wifi: ['M4.6 12.2a10.4 10.4 0 0 1 14.8 0', 'M8 15.7a5.6 5.6 0 0 1 8 0', 'M12 19.4h.01'],
  chart: ['M4 20.4V11M9.4 20.4V4.6M14.8 20.4v-6.6M20.2 20.4V8.4', 'M2 20.4h20'],
  shield: ['M12 3.2l7 2.8v6.1c0 4.6-3 7.6-7 9-4-1.4-7-4.4-7-9V6l7-2.8z', 'M9.2 12.2l2 2 3.6-3.8'],
  link: ['M10.5 13.6a4.6 4.6 0 0 0 6.5 0l2.1-2.1a4.6 4.6 0 0 0-6.5-6.5l-1.1 1.1',
         'M13.5 10.4a4.6 4.6 0 0 0-6.5 0l-2.1 2.1a4.6 4.6 0 0 0 6.5 6.5l1.1-1.1'],
  cpu: ['M6.6 4.2h10.8a2.4 2.4 0 0 1 2.4 2.4v10.8a2.4 2.4 0 0 1-2.4 2.4H6.6a2.4 2.4 0 0 1-2.4-2.4V6.6a2.4 2.4 0 0 1 2.4-2.4z',
        'M9.6 9.6h4.8v4.8H9.6z', 'M2.4 9.6h1.8M2.4 14.4h1.8M19.8 9.6h1.8M19.8 14.4h1.8M9.6 2.4v1.8M14.4 2.4v1.8M9.6 19.8v1.8M14.4 19.8v1.8'],
  activity: ['M2.6 12.4h3.8l3-7.4 4.2 14 3-6.6h4.8'],
  gear: ['M12 8.6a3.4 3.4 0 1 0 0 6.8 3.4 3.4 0 0 0 0-6.8z',
         'M12 2.4v2.8M12 18.8v2.8M4.2 4.2l2 2M17.8 17.8l2 2M2.4 12h2.8M18.8 12h2.8M4.2 19.8l2-2M17.8 6.2l2-2'],
  target: ['M12 3.4a8.6 8.6 0 1 0 0 17.2 8.6 8.6 0 0 0 0-17.2z', 'M12 8.4a3.6 3.6 0 1 0 0 7.2 3.6 3.6 0 0 0 0-7.2z', 'M12 11.6h.01'],
  zap: ['M13.4 2.6L5.6 13.4h5.4l-1 8 8-11h-5.6l1-7.8z'],
  code: ['M9 7.6l-4.4 4.4L9 16.4', 'M15 7.6l4.4 4.4L15 16.4'],
  database: ['M12 3.4c4.4 0 8 1.3 8 2.9s-3.6 2.9-8 2.9-8-1.3-8-2.9 3.6-2.9 8-2.9z',
             'M4 6.3v11.4c0 1.6 3.6 2.9 8 2.9s8-1.3 8-2.9V6.3', 'M4 12c0 1.6 3.6 2.9 8 2.9s8-1.3 8-2.9'],
  layers: ['M12 3.2l8.6 4.6-8.6 4.6L3.4 7.8 12 3.2z', 'M3.4 12.6l8.6 4.6 8.6-4.6', 'M3.4 16.6l8.6 4.6 8.6-4.6'],
  users: ['M15.6 20v-1.6a3.8 3.8 0 0 0-3.8-3.8H7.6a3.8 3.8 0 0 0-3.8 3.8V20',
          'M9.7 11.2a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2', 'M20.2 20v-1.6a3.8 3.8 0 0 0-2.9-3.7M15.4 4.2a3.6 3.6 0 0 1 0 7'],
  check: ['M20 6.8L9.4 17.4 4 12'],
  clock: ['M12 3.4a8.6 8.6 0 1 0 0 17.2 8.6 8.6 0 0 0 0-17.2z', 'M12 8v4.4l3.2 1.9'],
  spark: ['M12 3.2l2.1 5.3 5.3 2.1-5.3 2.1L12 18l-2.1-5.3L4.6 10.6l5.3-2.1L12 3.2z', 'M18.6 16.4l.7 1.8 1.8.7-1.8.7-.7 1.8-.7-1.8-1.8-.7 1.8-.7.7-1.8z'],
  'arrow-right': ['M4.6 12h14.2', 'M13.2 6.4l5.6 5.6-5.6 5.6'],
  'arrow-up': ['M12 19.4V4.8', 'M5.8 11l6.2-6.2L18.2 11'],
  'arrow-down': ['M12 4.6v14.6', 'M5.8 13l6.2 6.2L18.2 13'],
  phone: ['M6.4 3.2h3l1.6 4-2 1.4a12.6 12.6 0 0 0 6.4 6.4l1.4-2 4 1.6v3A2.6 2.6 0 0 1 18.2 20.6C10.4 19.8 4.2 13.6 3.4 5.8A2.6 2.6 0 0 1 6 3.2z'],
  mail: ['M4 5.6h16a1.6 1.6 0 0 1 1.6 1.6v9.6a1.6 1.6 0 0 1-1.6 1.6H4a1.6 1.6 0 0 1-1.6-1.6V7.2A1.6 1.6 0 0 1 4 5.6z',
         'M2.8 7.4l9.2 6 9.2-6'],
  location: ['M12 21.2s6.8-5.8 6.8-11a6.8 6.8 0 1 0-13.6 0c0 5.2 6.8 11 6.8 11z', 'M12 12.4a2.6 2.6 0 1 0 0-5.2 2.6 2.6 0 0 0 0 5.2z'],
  menu: ['M3.4 7h17.2M3.4 12h17.2M3.4 17h17.2'],
  close: ['M6 6l12 12M18 6L6 18'],
  leaf: ['M4.4 20c8.4.8 16-6.2 16-16C12 4 4.4 10.4 4.4 20z', 'M4.4 20c1.4-6 5.4-9.4 9.6-10.6'],
  factory: ['M3 20.4V10.2l5 3.2V10.2l5 3.2V10.2l5 3.2v7H3z', 'M2 20.4h20', 'M17.6 10.2V4.6h3.4v15.8'],
  water: ['M3.4 8.6h12.2a3 3 0 1 0-3-3', 'M3.4 13.4h16.2a3 3 0 1 1-3 3', 'M3.4 18.2h9'],
  chartBar: ['M5.4 20.4v-6.2M12 20.4V5.6M18.6 20.4v-9.2'],
  bell: ['M18 8.6a6 6 0 1 0-12 0c0 5.4-2 7.4-2 7.4h16s-2-2-2-7.4z', 'M14 19.4a2.2 2.2 0 0 1-4 0'],
  clipboard: [
    'M9 4.6h6a1.6 1.6 0 0 1 1.6 1.6v13.2a1.6 1.6 0 0 1-1.6 1.6H9a1.6 1.6 0 0 1-1.6-1.6V6.2A1.6 1.6 0 0 1 9 4.6z',
    'M9.8 4.6V3.4a1.4 1.4 0 0 1 1.4-1.4h1.6a1.4 1.4 0 0 1 1.4 1.4v1.2',
    'M10.6 11h4.8M10.6 15h3.2'
  ],
  play: ['M12 3.4a8.6 8.6 0 1 0 0 17.2 8.6 8.6 0 0 0 0-17.2z', 'M10.4 8.8l5.2 3.2-5.2 3.2V8.8z'],
  external: ['M14 4.6h5.4V10', 'M19.4 4.6l-8 8', 'M18 14.2v4.2a1.6 1.6 0 0 1-1.6 1.6H6.6A1.6 1.6 0 0 1 5 18.4V8.6A1.6 1.6 0 0 1 6.6 7H10.8'],
  key: ['M15.4 4.6a4.6 4.6 0 1 1-3.8 7.8l-1.8 1.8H8v1.8H6.2v1.8H3.2v-3l6.6-6.6a4.6 4.6 0 0 1 5.6-3.6z', 'M16.6 8.4h.01'],
  file: ['M13.6 3.4H7.6A1.6 1.6 0 0 0 6 5v14a1.6 1.6 0 0 0 1.6 1.6h10.8A1.6 1.6 0 0 0 20 19V9.8L13.6 3.4z', 'M13.6 3.4v6.4H20'],
  box: ['M12 3.2l8 4.2v9.2l-8 4.2-8-4.2V7.4l8-4.2z', 'M4 7.4l8 4.2 8-4.2', 'M12 11.6v10.2'],
  users2: ['M12 12.4a4 4 0 1 0 0-8 4 4 0 0 0 0 8z', 'M4.6 20.4a7.4 7.4 0 0 1 14.8 0'],
  plus: ['M12 5.4v13.2M5.4 12h13.2']
}

export default {
  name: 'IconSvg',
  props: {
    name: { type: String, required: true },
    stroke: { type: [Number, String], default: 1.6 }
  },
  computed: {
    paths() {
      return ICONS[this.name] || ICONS.spark
    }
  }
}
</script>

<style scoped>
/* 图标尺寸交给使用方：
   - 设 `--ico: 18px` 即按该尺寸渲染（推荐，写法确定、无特异性之争）；
   - 不设则由父容器撑满（兼容「父盒子定尺寸 + 内部 100%」的既有用法）。
   注意：本规则经 scoped 编译为 `.ico[data-v-x]`，特异性 (0,2,0)，
   会压过全局 `.btn svg`(0,1,1)——所以按钮内的图标尺寸必须走 --ico。 */
.ico {
  display: block;
  width: var(--ico, 100%);
  height: var(--ico, 100%);
}
</style>
